// extracted by mini-css-extract-plugin
module.exports = {"root":"GraphQLQueryText_root__C1RBk"};